<template>
    <v-overlay :value="visible">
        <v-progress-circular
        size="64"
        color="#C4170C"
        indeterminate
        ></v-progress-circular>
    </v-overlay>
</template>
<script>
export default {
    name:"BaseProgressCircular",
    props:{
        visible:{
            type:Boolean
        }
    }
}
</script>
<style scoped>

</style>